import styled from '@emotion/styled';
import { FC } from 'react';
import Div100vh from 'react-div-100vh';

import { PropsWithOnlyChildren } from 'app/types';

// Local Variables
const StyledDiv100vh = styled(Div100vh)({
  alignItems: 'stretch',
  display: 'flex',
  flexDirection: 'column',
});

// Component Definition
const Body: FC<PropsWithOnlyChildren> = props => (
  <StyledDiv100vh>
    {props.children}
  </StyledDiv100vh>
);

export default Body;
